import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IoMenu } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { FaAngleDown } from "react-icons/fa";

// Correct import paths (adjusted based on your folder structure)
import TopperImage from '../../../assets/About-page-assets/top_header.png';
import logoImg from '../../../assets/Home-page-assets/logo.png';
import earthIcon from '../../../assets/Home-page-assets/famicons_earth-outline.png';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [activeNavItem, setActiveNavItem] = useState('Home');
    const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
    const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        if (isMenuOpen) setIsMobileServicesOpen(false);
    };

    const handleNavItemClick = (item) => {
        setActiveNavItem(item);
        setIsMenuOpen(false);
        setIsMobileServicesOpen(false);
    };

    const navItems = [
        { name: 'Home', path: '/' },
        { name: 'About Us', path: '/about' },
        {
            name: 'Services',
            path: '#',
            children: [
                { name: 'Recharge API', path: '/services' },
                { name: 'BBPS API', path: '/BbpsApis' },
                { name: 'KYC API', path: '/KycApis' },
                { name: 'DOMAIN API', path: '/domain_api' },
                { name: 'TRAVEL API', path: '/travel_api' },
            ],
        },
        { name: 'Contact Us', path: '/Contact' },
    ];

    useEffect(() => {
        const currentItem = navItems.find(item =>
            item.path === location.pathname ||
            item.children?.some(sub => sub.path === location.pathname)
        );
        setActiveNavItem(currentItem ? currentItem.name : 'Home');
    }, [location.pathname]);

    // ✅ Styles
    const headerStyle = { position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 50 };

    const topBarStyle = {
        backgroundImage: `url(${TopperImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingRight: '30px',
        height: '45px',

    };


    const styles = {
        topBarRightText: {
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '16px',
            color: '#fff',
            fontWeight: 500,
        },
        earthIcon: { width: '22px', height: '22px' },
        logo: { height: '64px', marginTop: '34px' },
    };

    const navStyle = {
        height: '50px', width: '80%', display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', padding: '16px 0', margin: '0 auto', position: 'relative',
    };

    const logoContainerStyle = { display: 'flex', alignItems: 'center', gap: '12px', zIndex: 60 };
    const navListStyle = { display: 'flex', gap: '36px', fontWeight: 600, fontSize: '18px', color: 'white', listStyleType: 'none' };
    const navItemStyle = { cursor: 'pointer', color: 'white', display: 'flex', alignItems: 'center', position: 'relative' };
    const activeNavItemStyle = {
        color: '#00afef',
        background: 'linear-gradient(90deg, rgba(0, 175, 239, 1) 0%, rgba(6, 4, 56, 1) 100%)',
        backgroundSize: '100% 4px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom',
        paddingBottom: '2px',
    };

    const submenuContainerStyle = {
        position: 'absolute',
        top: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#0a0f2c',
        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.5)',
        borderRadius: '8px',
        minWidth: '220px',
        zIndex: 70,
        display: isSubmenuOpen ? 'block' : 'none',
        border: '1px solid #2F56A6',
        listStyleType: 'none',
        margin: 0,
    };

    const desktopSubmenuItemLinkStyle = {
        color: 'white',
        padding: '12px 16px',
        fontSize: '18px',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textDecoration: 'none',
        width: '100%',
    };

    const mediaQueries = `
        @media (max-width: 768px) {
            .desktop-nav { display: none !important; }
            .mobile-menu-button { display: block !important; }
        }

         @media (max-width: 570px) {
             .mobile-bg-shift {
            background-position: 60% center !important
            }
        }

        @media (max-width: 570px) {
            .email{
                gap: 4px;
                font-size: 12px !important;
            }
        }
    `;

    const mobileMenuButtonStyle = {
        display: 'none', fontSize: '32px', cursor: 'pointer', color: 'white', background: 'transparent', border: 'none', zIndex: 60,
    };

    const mobileMenuOverlayStyle = {
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        backgroundColor: 'rgba(10, 15, 44, 0.95)', zIndex: 55, display: 'flex',
        flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    };

    const mobileNavListStyle = {
        display: 'flex', flexDirection: 'column', gap: '32px', fontWeight: 600,
        fontSize: '20px', color: 'white', padding: '40px 20px', alignItems: 'center',
        justifyContent: 'center', height: '100vh', listStyleType: 'none',
    };

    return (
        <header style={headerStyle}>
            <style>
                {mediaQueries}  
            </style>

            {/* ✅ Top Bar */}
            <div className="top-bar mobile-bg-shift" style={topBarStyle}>
                <div>
                    <span className="email" style={styles.topBarRightText}>
                        <img src={earthIcon} alt="Earth Icon" style={styles.earthIcon} />
                        <span>support@apigalaxy.com</span>
                    </span>
                </div>
            </div>

            {/* ✅ Navbar */}
            <nav style={navStyle} className="nav-container">
                <div style={logoContainerStyle}>
                    <img src={logoImg} alt="API Galaxy Logo" style={styles.logo} />
                </div>

                {/* Desktop Navigation */}
                <div className="desktop-nav">
                    <ul style={navListStyle}>
                        {navItems.map((item) => {
                            const isServices = !!item.children;
                            const isActive = activeNavItem === item.name;

                            return (
                                <li
                                    key={item.name}
                                    style={{ ...navItemStyle, ...(isActive ? activeNavItemStyle : {}) }}
                                    onMouseEnter={() => isServices && setIsSubmenuOpen(true)}
                                    onMouseLeave={() => isServices && setIsSubmenuOpen(false)}
                                >
                                    <Link
                                        to={isServices ? '#' : item.path}
                                        style={{ color: 'inherit', textDecoration: 'none' }}
                                        onClick={() => !isServices && handleNavItemClick(item.name)}
                                    >
                                        {item.name}
                                    </Link>
                                    {isServices && (
                                        <>
                                            <span style={{ marginLeft: '4px', position: 'absolute', right: 0 }}>
                                                <IoIosArrowDown size={18} />
                                            </span>
                                            <ul style={submenuContainerStyle}>
                                                {item.children.map((subItem, subIndex) => (
                                                    <li key={subIndex}>
                                                        <Link
                                                            to={subItem.path}
                                                            style={desktopSubmenuItemLinkStyle}
                                                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(47, 86, 166, 0.57)')}
                                                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                                                            onClick={() => {
                                                                handleNavItemClick(item.name);
                                                                setIsSubmenuOpen(false);
                                                            }}
                                                        >
                                                            <span>{subItem.name}</span>
                                                            <FaAngleDown style={{ color: '#00afef' }} />
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>

                {/* Mobile Menu Button */}
                <button
                    style={mobileMenuButtonStyle}
                    className="mobile-menu-button"
                    onClick={toggleMenu}
                >
                    {isMenuOpen ? <RxCross2 /> : <IoMenu />}
                </button>

                {/* Mobile Menu Overlay */}
                {isMenuOpen && (
                    <div style={mobileMenuOverlayStyle}>
                        <ul style={mobileNavListStyle}>
                            {/* {navItems.map((item) => (
                                <li key={item.name}>
                                    <Link
                                        to={item.path}
                                        style={{ color: 'white', textDecoration: 'none', fontSize: '20px' }}
                                        onClick={() => handleNavItemClick(item.name)}
                                    >
                                        {item.name}
                                    </Link>
                                </li>
                            ))} */}

                            {navItems.map((item) => {
                                const isServices = !!item.children;

                                return (
                                    <li key={item.name} style={{ width: '100%', textAlign: 'center' }}>
                                        {isServices ? (
                                            <>
                                                <div
                                                    onClick={() => setIsMobileServicesOpen(!isMobileServicesOpen)}
                                                    style={{
                                                        color: 'white',
                                                        fontSize: '20px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '8px',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {item.name}
                                                    {isMobileServicesOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                </div>

                                                {isMobileServicesOpen && (
                                                    <ul style={{
                                                        marginTop: '12px',
                                                        paddingLeft: '20px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '16px',
                                                        fontSize: '18px',
                                                        listStyle: 'none',
                                                    }}>
                                                        {item.children.map((sub) => (
                                                            <li key={sub.name}>
                                                                <Link
                                                                    to={sub.path}
                                                                    style={{ color: '#00afef', textDecoration: 'none' }}
                                                                    onClick={() => {
                                                                        handleNavItemClick('Services');
                                                                        setIsMenuOpen(false);
                                                                        setIsMobileServicesOpen(false);
                                                                    }}
                                                                >
                                                                    {sub.name}
                                                                </Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </>
                                        ) : (
                                            <Link
                                                to={item.path}
                                                style={{ color: 'white', textDecoration: 'none', fontSize: '20px' }}
                                                onClick={() => {
                                                    handleNavItemClick(item.name);
                                                    setIsMenuOpen(false);
                                                }}
                                            >
                                                {item.name}
                                            </Link>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
            </nav>
        </header>
    );
};

export default Navbar;
